import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { usePromoCodeState } from './usePromoCodeState'

type TPromoCodeStateProps = FirstParam<typeof usePromoCodeState>
type TPromoContext = ReturnType<typeof usePromoCodeState>

type TProps = RequiredChildren & TPromoCodeStateProps

const [ValueProvider, usePromoCodesCtx] = createContext<TPromoContext>(`PromoCodes`)

/**
 * Provides an array of current promo codes of the order in the form
 * and operations for adding and removing codes from that order.
 */
export const PromoCodeProvider: React.FC<TProps> = ({ refetchQueries, children }) => {
  const promoContext = usePromoCodeState({ refetchQueries })

  return <ValueProvider value={promoContext}>{children}</ValueProvider>
}

export { usePromoCodesCtx }
